import React from "react";
import { withNavBars } from "../../HOCs";
import FormBuilder from "./formBuilder"
class FormBuilderParent extends React.Component {
  render() {
    return <FormBuilder />;
  }
}
const props = {
  boxShadow: false,
};
export default withNavBars(FormBuilderParent, props);